import React, { useEffect } from 'react';

const AdSenseArticle = () => {
    useEffect(() => {
        // Richiama il push di AdSense dopo ogni render
        if (typeof window !== 'undefined' && window.adsbygoogle) {
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (e) {
                console.error('AdSense error:', e);
            }
        }
    }, []);

    return (
        <div>
            <div>
                <ins className="adsbygoogle"
                    style={{display:"block"}}
                    data-ad-client="ca-pub-1869865175337028"
                    data-ad-slot="2350233728"
                    data-ad-format="auto"
                    data-full-width-responsive="true"></ins>
            </div>
        </div>
    );
};

export default AdSenseArticle;
